export interface CheckboxOption {
  label: string;
  timeLabel: string;
  value: string;
}

export const timeOptions: CheckboxOption[] = [
  { label: "00:00:00", timeLabel: "12:00 AM", value: "UTC_00_00" },
  { label: "01:00:00", timeLabel: "01:00 AM", value: "UTC_01_00" },
  { label: "02:00:00", timeLabel: "02:00 AM", value: "UTC_02_00" },
  { label: "03:00:00", timeLabel: "03:00 AM", value: "UTC_03_00" },
  { label: "04:00:00", timeLabel: "04:00 AM", value: "UTC_04_00" },
  { label: "05:00:00", timeLabel: "05:00 AM", value: "UTC_05_00" },
  { label: "06:00:00", timeLabel: "06:00 AM", value: "UTC_06_00" },
  { label: "07:00:00", timeLabel: "07:00 AM", value: "UTC_07_00" },
  { label: "08:00:00", timeLabel: "08:00 AM", value: "UTC_08_00" },
  { label: "09:00:00", timeLabel: "09:00 AM", value: "UTC_09_00" },
  { label: "10:00:00", timeLabel: "10:00 AM", value: "UTC_10_00" },
  { label: "11:00:00", timeLabel: "11:00 AM", value: "UTC_11_00" },
  { label: "12:00:00", timeLabel: "12:00 PM", value: "UTC_12_00" },
  { label: "13:00:00", timeLabel: "01:00 PM", value: "UTC_13_00" },
  { label: "14:00:00", timeLabel: "02:00 PM", value: "UTC_14_00" },
  { label: "15:00:00", timeLabel: "03:00 PM", value: "UTC_15_00" },
  { label: "16:00:00", timeLabel: "04:00 PM", value: "UTC_16_00" },
  { label: "17:00:00", timeLabel: "05:00 PM", value: "UTC_17_00" },
  { label: "18:00:00", timeLabel: "06:00 PM", value: "UTC_18_00" },
  { label: "19:00:00", timeLabel: "07:00 PM", value: "UTC_19_00" },
  { label: "20:00:00", timeLabel: "08:00 PM", value: "UTC_20_00" },
  { label: "21:00:00", timeLabel: "09:00 PM", value: "UTC_21_00" },
  { label: "22:00:00", timeLabel: "10:00 PM", value: "UTC_22_00" },
  { label: "23:00:00", timeLabel: "11:00 PM", value: "UTC_23_00" }
];
